(() => {
  if (window.ProductSeriesLpTabs) {
    window.ProductSeriesLpTabs.initAll();
    return;
  }

  const rootSelector = '[data-product-series-lp]';

  function activateTab(root, activeButton) {
    const buttons = root.querySelectorAll('[data-product-series-tab]');
    const panels = root.querySelectorAll('[data-product-series-panel]');
    const targetPanelId = activeButton.getAttribute('aria-controls');
    const targetPanel = Array.from(panels).find((panel) => panel.id === targetPanelId);

    if (!targetPanel) return;

    buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('-is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const isActive = panel.id === targetPanelId;
      panel.classList.toggle('-is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  function initTabs(root) {
    if (!root || root.dataset.productSeriesTabsInitialized === 'true') return;

    const buttons = Array.from(root.querySelectorAll('[data-product-series-tab]'));
    if (buttons.length === 0) return;

    root.dataset.productSeriesTabsInitialized = 'true';

    const initialButton = buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0];
    activateTab(root, initialButton);

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activateTab(root, button));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;

        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + buttons.length) % buttons.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % buttons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = buttons.length - 1;

        buttons[nextIndex].focus();
        activateTab(root, buttons[nextIndex]);
      });
    });
  }

  function initAll(scope = document) {
    if (scope.matches?.(rootSelector)) initTabs(scope);
    scope.querySelectorAll?.(rootSelector).forEach(initTabs);
  }

  window.ProductSeriesLpTabs = { initAll };

  initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const selectedTab = event.target.closest?.('[data-product-series-tab]');
    const selectedTabRoot = selectedTab?.closest(rootSelector);
    if (selectedTab && selectedTabRoot) {
      activateTab(selectedTabRoot, selectedTab);
      return;
    }

    const panel = event.target.closest?.('[data-product-series-panel]');
    const root = panel?.closest(rootSelector);
    if (!panel || !root) return;

    const button = root.querySelector(`[aria-controls="${panel.id}"]`);
    if (button) activateTab(root, button);
  });
})();
